import {
  unregisterSpecificNotificationHandler,
  registerSpecificNotificationHandler,
} from '../../bridge';
import { isAvailable } from 'jssdk/utils';
import type { NetworkState } from './types';

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * network.onNetworkStateChanged
 *
 * [PLATFORM]
 * mac        6.0.5+
 * windows    6.0.5+
 * linux      6.0.5+
 * ios        NotSupport
 * android    NotSupport
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export async function onNetworkStateChanged(
  networkStateChangedCallback: (networkState: NetworkState) => void
) {
  await isAvailable('network.onNetworkStateChanged');
  registerSpecificNotificationHandler(
    'UnifyNotif_OnNetworkStateChanged',
    networkStateChangedCallback
  );
}

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * network.offNetworkStateChanged
 *
 * [PLATFORM]
 * mac        6.0.5+
 * windows    6.0.5+
 * linux      6.0.5+
 * ios        NotSupport
 * android    NotSupport
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export async function offNetworkStateChanged(
  networkStateChangedCallback: (networkState: NetworkState) => void
) {
  await isAvailable('network.offNetworkStateChanged');
  unregisterSpecificNotificationHandler(
    'UnifyNotif_OnNetworkStateChanged',
    networkStateChangedCallback
  );
}

export default {
  onNetworkStateChanged,
  offNetworkStateChanged,
};
